export const phoneMediaQuery = '(max-width: 650px)'
export const phoneTabletMediaQuery = '(max-width: 959px)'
export const tabletMediaQuery = 'max-width: 1023px'
